import React, {useContext, useState, useEffect} from "react";
import { UserContext } from "../Context/UserContext";
import "../styles/teamTrends.css"

function SingleGameTeamTrends({relevantGame, trends, ratingTimeframe}) {
    const {state} = useContext(UserContext)
    //console.log('ratingTimeFrame on Trends', ratingTimeframe)
    //console.log('relGame', relevantGame)
    //console.log('trends', trends)
    const [teamWithMoreERH, setTeamWithMoreERH] = useState("")
    //console.log('team with more ERH', teamWithMoreERH)
    const [teamWithMoreGRH, setTeamWithMoreGRH] = useState("")
    //console.log('team with more GRH',teamWithMoreGRH)
    const [teamWithHigherMR, setTeamWithHigherMR] = useState("")
    const [dataTimeframe, setDataTimeFrame] = useState("three_year")
    //console.log('dataTimeFrame', dataTimeframe)

    const homeTeamTrends = trends?.find((trend) => String(trend?.team) === String(relevantGame?.home_team)) || {}
    //console.log('homeTeamTrends', homeTeamTrends)
    const awayTeamTrends = trends?.find((trend) => String(trend?.team) === String(relevantGame?.away_team)) || {}
    //console.log('awayTeamTrends', awayTeamTrends)

    const awayAvgMatchupRating = `away_team_${dataTimeframe}_avg_hitter_matchup_rating`
    const homeAvgMatchupRating = `home_team_${dataTimeframe}_avg_hitter_matchup_rating`

    const awayERH = `away_team_${dataTimeframe}_erh`
    const homeERH = `home_team_${dataTimeframe}_erh`

    const awayGRH = `away_team_${dataTimeframe}_grh`
    const homeGRH = `home_team_${dataTimeframe}_grh`

    const homeTeamPrimaryColor = state.teamColors[relevantGame?.home_team]?.primary || "transparent"
    const homeTeamSecondaryColor = state.teamColors[relevantGame?.home_team]?.secondary || "transparent"
    const awayTeamPrimaryColor = state.teamColors[relevantGame?.away_team]?.primary || "transparent"
    const awayTeamSecondaryColor = state.teamColors[relevantGame?.away_team]?.secondary || "transparent"

    useEffect(() => {
        function checkTimeFrame() {
            if (ratingTimeframe) {
                setDataTimeFrame("current_season")
            }
            else {
                setDataTimeFrame("three_year")
            }
        }

        function checkEliteDifference() {
            if (relevantGame?.[awayERH] > relevantGame?.[homeERH]) {
                setTeamWithMoreERH(relevantGame?.away_team)
            }
            else if (relevantGame?.[homeERH] > relevantGame?.[awayERH]) {
                setTeamWithMoreERH(relevantGame?.home_team)
            }
            //console.log('team with more ERH in check Elite', teamWithMoreERH)
        }

        function checkGreatDifference() {
            if (relevantGame[awayGRH] > relevantGame[homeGRH]) {
                setTeamWithMoreGRH(relevantGame?.away_team)
            }
            else if (relevantGame[homeGRH] > relevantGame[awayGRH]) {
                setTeamWithMoreGRH(relevantGame?.home_team)
            }
            //console.log('team with more GRH in check Great', teamWithMoreGRH)
        }

        function checkMatchupRatingDifference() {
            if (relevantGame[awayAvgMatchupRating] > 0.0 && relevantGame[homeAvgMatchupRating] > 0.0) {
                if (relevantGame[awayAvgMatchupRating] > relevantGame[homeAvgMatchupRating]) {
                    setTeamWithHigherMR(relevantGame?.away_team)
                }
                else if (relevantGame[homeAvgMatchupRating] > relevantGame[awayAvgMatchupRating]) {
                    setTeamWithHigherMR(relevantGame?.home_team)
                }
            }
        }

        checkTimeFrame()
        checkEliteDifference()
        checkGreatDifference()
        checkMatchupRatingDifference()
    }, [relevantGame, teamWithMoreERH, teamWithMoreGRH, teamWithHigherMR, ratingTimeframe, awayAvgMatchupRating, homeAvgMatchupRating, awayERH, homeERH, awayGRH, homeGRH])

    function renderMoreRatedHittersWinPcts(trend, field_suffix) {
        const moreRatedHittersWinPct = `more_${dataTimeframe}_${field_suffix}_win_pct`
        const todayDiffWinPct = `today_diff_${dataTimeframe}_${field_suffix}_win_pct`
        const numGamesMoreHitters = `num_games_with_more_${dataTimeframe}_${field_suffix}`
        const numGamesTodayDiff = `num_games_with_today_diff_${dataTimeframe}_${field_suffix}`
        const todayDiff = `${dataTimeframe}_${field_suffix}_diff_from_opp`

        const field_suffix_check = field_suffix === "grh" ? "srh" : "erh"

        return (
            <div>
                <li>Won {trend[moreRatedHittersWinPct]}% Games With More {field_suffix_check.toUpperCase()} Since Start of 2024 ({trend[numGamesMoreHitters]} Games)</li>
                {trend[todayDiff] > 1 && (<li>Won {trend[todayDiffWinPct]}% Games With A +{trend[todayDiff]} {field_suffix_check.toUpperCase()} Since Start of 2024 ({trend[numGamesTodayDiff]} Games)</li>)}
            </div>
        )
    }

    function renderHigherMatchupRatingWinPct(trend) {
        const betterWinPct = `better_${dataTimeframe}_matchup_rating_win_pct`
        const sampleSize = `num_games_with_higher_${dataTimeframe}_avg_hitter_matchup_rating`
        return (
            <div>
                <li>Won {trend[betterWinPct]}% Games With A Higher Matchup Rating Than Opponent Since Start of 2024 ({trend[sampleSize]} Games)</li>
            </div>
        )
    }

    function renderTeamTotalInsights(trendsObj) {
        //console.log('trendsObj', trendsObj)
        const sampleSize = `num_games_similar_avg_matchup_rating_${dataTimeframe}`
        const threePlusRunsPct = `percent_three_plus_runs_${dataTimeframe}_avg_mr`
        const fourPlusRunsPct = `percent_four_plus_runs_${dataTimeframe}_avg_mr`
        const fivePlusRunsPct = `percent_five_plus_runs_${dataTimeframe}_avg_mr`
        const sixPlusRunsPct = `percent_six_plus_runs_${dataTimeframe}_avg_mr`
        const sevenPlusRunsPct = `percent_seven_plus_runs_${dataTimeframe}_avg_mr`
        
        return (
            <div>
                <li>Scored 3+ Runs {trendsObj[threePlusRunsPct]}% ({trendsObj[sampleSize]} Games)</li>
                <li>Scored 4+ Runs {trendsObj[fourPlusRunsPct]}%</li>
                <li>Scored 5+ Runs {trendsObj[fivePlusRunsPct]}%</li>
                <li>Scored 6+ Runs {trendsObj[sixPlusRunsPct]}%</li>
                <li>Scored 7+ Runs {trendsObj[sevenPlusRunsPct]}%</li>
            </div>
        )
    }

    function renderBothTeamInsights() {
        return (
            <div className="teamInsightsContent">
                    <div style={{backgroundColor: awayTeamPrimaryColor, border: `0.25rem solid ${awayTeamSecondaryColor}`, borderRadius: '0.75rem'}} className="awayTeamContent">
                        <h2>{relevantGame?.away_team}</h2>
                        {Object.keys(awayTeamTrends).length > 0 ? (
                        <div>
                            <li>Today's Average Matchup Rating: {relevantGame[awayAvgMatchupRating].toFixed(3)}</li>
                            {teamWithHigherMR === relevantGame.away_team && renderHigherMatchupRatingWinPct(awayTeamTrends)}
                            {relevantGame[awayERH] > 1 && (<li>{relevantGame[awayERH]} Elite Rated Hitters (ERH)</li>)}
                            {relevantGame[awayERH] === 1 && (<li>{relevantGame[awayERH]} Elite Rated Hitter (ERH)</li>)}
                            {teamWithMoreERH === relevantGame.away_team && renderMoreRatedHittersWinPcts(awayTeamTrends, "erh")}
                            {relevantGame[awayGRH] > 1 && (<li>{relevantGame[awayGRH]} Strong Rated Hitters (SRH)</li>)}
                            {relevantGame[awayGRH] === 1 && (<li>{relevantGame[awayGRH]} Strong Rated Hitter (SRH)</li>)}
                            {teamWithMoreGRH === relevantGame.away_team && renderMoreRatedHittersWinPcts(awayTeamTrends, "grh")}
                            <br />
                            {renderTeamTotalInsights(awayTeamTrends)}
                        </div>
                        ) : 
                        <div>
                            <li>No Ratings or Team Trends</li>
                            <li>Opposing Pitcher Doesn't Have Enough Data</li>
                        </div>
                        }
                    </div>
                    <div style={{backgroundColor: homeTeamPrimaryColor, border: `0.25rem solid ${homeTeamSecondaryColor}`, borderRadius: '0.75rem'}} className="homeTeamContent">
                        <h2>{relevantGame?.home_team}</h2>
                        {Object.keys(homeTeamTrends).length > 0 ? (
                        <div>
                            <li>Today's Average Matchup Rating: {relevantGame[homeAvgMatchupRating].toFixed(3)}</li>
                            {teamWithHigherMR === relevantGame.home_team && renderHigherMatchupRatingWinPct(homeTeamTrends)}
                            {relevantGame[homeERH] > 1 && (<li>{relevantGame[homeERH]} Elite Rated Hitters (ERH)</li>)}
                            {relevantGame[homeERH] === 1 && (<li>{relevantGame[homeERH]} Elite Rated Hitter (ERH)</li>)}
                            {teamWithMoreERH === relevantGame.home_team && renderMoreRatedHittersWinPcts(homeTeamTrends, "erh")}
                            {relevantGame[homeGRH] > 1 && (<li>{relevantGame[homeGRH]} Strong Rated Hitters (SRH)</li>)}
                            {relevantGame[homeGRH] === 1 && (<li>{relevantGame[homeGRH]} Strong Rated Hitter (SRH)</li>)}
                            {teamWithMoreGRH === relevantGame.home_team && renderMoreRatedHittersWinPcts(homeTeamTrends, "grh")}
                            <br />
                            {renderTeamTotalInsights(homeTeamTrends)}
                        </div>
                        ) : 
                        <div>
                            <li>No Ratings or Team Trends</li>
                            <li>Opposing Pitcher Doesn't Have Enough Data</li>
                        </div>
                        }
                    </div>
            </div>
        )
    }

    return (
        <div>
            {/* <h2 id="teamTrendsH2">Team Insights</h2> */}
            {ratingTimeframe === false && (<div className="teamInsightsContainer">
                <div className="teamInsightsNotes">
                    <li>Note: All team insights based on matchup ratings for today</li>
                    <li>Example: Scored 3+ runs with average matchup rating similar to today's</li>
                </div>
                {renderBothTeamInsights()}
            </div>)}
        </div>
    )
}

export default SingleGameTeamTrends